/**
 * @param {Element} component
 * @returns {Function} A callback function
 */
const handleSorting = (component) => () => {
    $(component).find('.data-sorting').tablesorter({
        sortList: [[2, 0]],
    });
};

export default handleSorting;



// WEBPACK FOOTER //
// ./src/scripts/components/switcher/handleSorting.js